import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import styles from './TrendingPanel.module.css';

export default function TrendingPanel({ onScreen }) {
  const { t } = useTranslation();
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState('');

  const fetchTrending = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const { data: res } = await axios.get('/api/trending');
      setData(res.results || []);
    } catch (err) {
      setError(err.response?.data?.error || t('trending.error'));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchTrending(); }, [fetchTrending]);

  const filtered = data || [];

  return (
    <div className={styles.section}>
      {/* ── Header ── */}
      <div className={styles.header}>
        <div className={styles.titleRow}>
          <div className={styles.liveDot} />
          <span className={styles.label}>{t('trending.label')}</span>
        </div>
      </div>

      {/* ── Body ── */}
      {loading && (
        <div className={styles.loading}>
          <div className={styles.spinner} />
          <span>{t('trending.loading')}</span>
        </div>
      )}

      {!loading && error && (
        <div className={styles.empty}>{error}</div>
      )}

      {!loading && !error && filtered.length === 0 && (
        <div className={styles.empty}>{t('trending.empty')}</div>
      )}

      {!loading && !error && filtered.length > 0 && (
        <div className={styles.grid}>
          {filtered.map(stock => {
            const pct      = stock.changePct || 0;
            const changeClass = pct > 0 ? styles.changePos : pct < 0 ? styles.changeNeg : styles.changeNeu;
            const changeSign  = pct > 0 ? '+' : '';
            const verdictClass = stock.verdict === 'COMPLIANT' ? styles.verdictCompliant : styles.verdictConditional;
            const verdictLabel = stock.verdict === 'COMPLIANT' ? t('trending.verdict.compliant') : t('trending.verdict.conditional');

            return (
              <div key={stock.symbol} className={styles.card} onClick={() => onScreen(stock.symbol)}>
                <div className={styles.cardTop}>
                  <div>
                    <div className={styles.cardSymbol}>{stock.symbol}</div>
                    {stock.quoteType === 'ETF' && <div className={styles.etfTag}>{t('trending.etf_tag')}</div>}
                  </div>
                  <span className={`${styles.verdictBadge} ${verdictClass}`}>{verdictLabel}</span>
                </div>
                <div className={styles.cardName}>{stock.name}</div>
                <div className={styles.cardBottom}>
                  <span className={styles.price}>{stock.price ? '$' + stock.price.toFixed(2) : '—'}</span>
                  <span className={`${styles.change} ${changeClass}`}>
                    {changeSign}{pct.toFixed(2)}%
                  </span>
                </div>
                {stock.sector && stock.sector !== 'N/A' && (
                  <div className={styles.sector}>{stock.sector} · {stock.industry}</div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
